import { render, staticRenderFns } from "./my-table.vue?vue&type=template&id=1858be7e&scoped=true"
import script from "./my-table.vue?vue&type=script&lang=js"
export * from "./my-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1858be7e",
  null
  
)

export default component.exports